import ApplicationAdapter from "./application";

export default class NetworkAdapterAdapter extends ApplicationAdapter {
  urlForFindRecord(id) {
    return `${this.apiBaseUri}/networkadapter/details?networkadapterid=${id}`;
  }
  urlForCreateRecord() {
    return `${this.apiBaseUri}/networkadapter/create`;
  }

  urlForUpdateRecord(id) {
    return `${this.apiBaseUri}/networkadapter/edit?networkadapterid=${id}`;
  }

  urlForDeleteRecord(id) {
    return `${this.apiBaseUri}/networkadapter/delete?networkadapterid=${id}`;
  }
}
